import { TagVariant } from "@stenajs-webui/elements";
import { ParentHistoryEntry } from "../types";

/**
 * Where a stretch sits relative to today, which is what decides what can
 * be done to it.
 *
 * A future stretch has never priced a single day, so it can be deleted
 * outright. A current one has, so the most that can be done is to give it
 * an end date. A past one is a record of what was charged and is read only.
 */
export type ParentStretchState = "PAST" | "ACTIVE" | "FUTURE";

export const parentStretchState = (
  entry: ParentHistoryEntry,
  today: string
): ParentStretchState => {
  if (entry.validFrom > today) {
    return "FUTURE";
  }
  if (entry.validTo !== null && entry.validTo < today) {
    return "PAST";
  }
  return "ACTIVE";
};

/**
 * How a stretch is badged. Past is stated without colour weight, the one
 * in force is the good case, and a future one is flagged because it is
 * waiting to happen and is the only kind that can still be taken away.
 */
export const parentStretchTag = (
  state: ParentStretchState
): { label: string; variant: TagVariant } => {
  switch (state) {
    case "PAST":
      return { label: "Past", variant: "info" };
    case "ACTIVE":
      return { label: "Active", variant: "success" };
    case "FUTURE":
      return { label: "Future", variant: "warning" };
  }
};
